import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6f0fc74"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-render ant-pro-global-footer" }
const _hoisted_2 = { class: "ant-pro-global-footer-links" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.antdv.com",
  target: "_blank"
}, "Ant Design Vue", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  title: "github",
  target: "_blank",
  href: "https://github.com/vueComponent/ant-design-vue"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "img",
    "aria-label": "github",
    class: "anticon anticon-github"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      viewBox: "64 64 896 896",
      focusable: "false",
      class: "",
      "data-icon": "github",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0138.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z" })
    ])
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://store.antdv.com/pro/",
  target: "_blank"
}, "Buy Now!", -1))
const _hoisted_6 = { class: "ant-pro-global-footer-copyright" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "copyright",
  class: "anticon anticon-copyright"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "64 64 896 896",
    focusable: "false",
    class: "",
    "data-icon": "copyright",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!

  return (_openBlock(), _createBlock(_component_a_layout_footer, { style: {"padding":"0"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "links", {}, () => [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5
          ], true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "copyright", {}, () => [
            _createTextVNode(" Copyright "),
            _hoisted_7,
            _createTextVNode(" 上海偲诺软件科技中心出品 ")
          ], true)
        ])
      ])
    ]),
    _: 3
  }))
}